import {Component, OnInit, Output} from '@angular/core';
//import * as kurentoUtils from 'kurento-utils';
import {WebsocketService} from '../Services/websocket.service';
import {VideoStatus} from '../Services/kurento.service';
import {Subject, Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RealmService} from '../Services/Realm/realm.service';
import {SessionService} from '../Services/Session/session-service.service';
import { MessageService } from 'primeng/api';
import {environment} from '../../environments/environment';
// require('src/assets/js/kurento.js');
declare var jQuery: any;
// tslint:disable-next-line:prefer-const
let videoInput;
// tslint:disable-next-line:prefer-const
let videoOutput;
// tslint:disable-next-line:prefer-const
let webRtcPeer;
// const registerName = null;
let ws = null;
const NOT_REGISTERED = 0;
const REGISTERING = 1;
const REGISTERED = 2;
let registerState = null;
const NO_CALL = 0;
const PROCESSING_CALL = 1;
const IN_CALL = 2;
let callState = null;
let parentCall = '';
let card = '';
function setCallState(nextState) {
  switch (nextState) {
    case NO_CALL:
      // $('#call').attr('disabled', false);
      // $('#terminate').attr('disabled', true);
      break;

    case PROCESSING_CALL:
      // $('#call').attr('disabled', true);
      //  $('#terminate').attr('disabled', true);
      break;
    case IN_CALL:
      //  $('#call').attr('disabled', true);
      // $('#terminate').attr('disabled', false);
      break;
    default:
      return;
  }
  callState = nextState;
}
function sendMessage(message) {
  const jsonMessage = JSON.stringify(message);
  console.log('Sending message: ' + jsonMessage);
  console.log('ws: ' + ws.url);
  try {
    ws.send(jsonMessage);
  } catch (e) {
    console.log('wserror', e);
  }
}
@Component({
  selector: 'app-telemedicine',
  templateUrl: './telemedicine.component.html',
  styleUrls: ['./telemedicine.component.css'],
  providers: [MessageService],
})
export class TelemedicineComponent implements OnInit {
  id = '';
  displayWaitDialog = true;
  quequeVariable: string;
  quequePosition: number;
  quequeTime: string;
  isOnline: string;
  uploadedFiles: any[] = [];
  env = environment;
// let ws = new WebSocket('ws://3.228.131.115:80/video/callMP');
  // tslint:disable-next-line:max-line-length
  constructor( private messageService: MessageService, private activatedRoute: ActivatedRoute, private realm: RealmService, private router: Router, private session: SessionService) {
  }
  onUpload(event) {
    for (const file of event.files) {
        this.uploadedFiles.push(file);
    }

    this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Upload Completed' });
}
  connect() {
    // ws = new WebSocket('wss://localhost:8443/one2one');
    // wss://localhost:8443/one2one
    ws = new WebSocket('wss://video.mediprocesos.com/video/callMP');
  }
  ngOnInit(): void {
    this.connect();
    this.env.showSteps = false;
    videoInput = document.getElementById('videoInput');
    videoOutput = document.getElementById('videoOutput');
    ws.onopen = message => {
      if ( message.type === 'open') {
        this.register('502605020');
      }
      navigator.mediaDevices.getUserMedia()
        .then(mediaStream => {
          const video = document.querySelector('video');
          video.srcObject = mediaStream;
          video.onloadedmetadata = ev =>  {
            video.play().then(r => {});
          };
        })
        .catch(err => { console.log(err.name + ': ' + err.message); }); // always check for errors at the end.
      // this.registersw();
      console.log('onopen: ', message);
    };
    ws.onerror = error => {
      // Alert('No se pudo conectar con el servidor...');
      // this.registersw();
      console.log('received Error: ', error);
    };
    ws.onmessage = message => {
      const parsedMessage = JSON.parse(message.data);
      console.log('Received message: ' + message.data);

      switch (parsedMessage.id) {
        case 'registerResponse':
          this.resgisterResponse(parsedMessage);
          if (parsedMessage.response === 'accepted') {
            //this.call();
          }
          console.log('registerResponse', parsedMessage);
          break;
        case 'callResponse':
          this.callResponse(parsedMessage);
          if ( parsedMessage.response === 'rejected') {
            // this.call();
          }
          console.log('callResponse');
          break;
        case 'incomingCall':
          this.incomingCall(parsedMessage);
          console.log('INCOMING CALL');
          break;
        case 'startCommunication':
          this.startCommunication(parsedMessage);
          console.log('INCALL');
          break;
        case 'stopCommunication':
          console.log('Communication ended by remote peer');
          this.stop(true);
          break;
        case 'iceCandidate':
         webRtcPeer.addIceCandidate(parsedMessage.candidate);
         console.log('iceCandidate');
         break;
        default:
          console.log('Unrecognized message', parsedMessage);
      }
    };
    this.activatedRoute.paramMap.subscribe(params => {
      this.id = params.get('id');
      parentCall = params.get('code');
    });
    this.realm.loginAsync().then(d => {
      this.realm.quequeQuery(this.id);
    });
    this.realm.quequeProvider$.subscribe( data => {
      const queque = data[0].queque;
      this.isOnline = JSON.parse(data[0].offline);
      if (this.isOnline !== null  && this.isOnline) {
        this.displayWaitDialog = false;
        this.quequePosition = queque;
        this.quequeTime = (queque * 20).toString();
        if ( queque > 0) {
          this.quequeVariable = '';
        } else {
          if (queque === -1) {
            this.quequeVariable = 'Es Su turno esperando que el Doctor acepte su llamada.';
          }
        }
      } else {
        this.quequePosition = null;
        this.quequeTime = '';
      }
    });
    console.log(this.id);
    console.log(parentCall);
  }
  async registersw() {
    //this.stop(true);
    card = await this.session.getvvalueSession('data', 'cardNumber');
    console.log(card);
    this.register(card);
    this.displayWaitDialog = false;
    this.call();
  }
  exitWait() {
    this.router.navigate(['/providers']);
  }
  resgisterResponse(message) {
    if (message.response === 'accepted') {
      this.setRegisterState(REGISTERED);
    } else {
      this.setRegisterState(NOT_REGISTERED);
      const errorMessage = message.message ? message.message
        : 'Unknown reason for register rejection.';
      console.log(errorMessage);
     // alert('Error registering user. See console for further information.');
    }
  }
  callResponse(message) {
    if (message.response !== 'accepted') {
      console.log('Call not accepted by peer. Closing call');
      const errorMessage = message.message ? message.message
        : 'Unknown reason for call rejection.';
      console.log(errorMessage);
      // this.stop(true);
    } else {
      setCallState(IN_CALL);
      webRtcPeer.processAnswer(message.sdpAnswer);
    }
  }
  startCommunication(message) {
    setCallState(IN_CALL);
    webRtcPeer.processAnswer(message.sdpAnswer);
  }
  incomingCall(message) {
    let response;
// If bussy just reject without disturbing user
    if (callState !== NO_CALL) {
      response = {
        id : 'incomingCallResponse',
        from : message.from,
        callResponse : 'reject',
        message : 'bussy'

      };
      return sendMessage(response);
    }

    setCallState(PROCESSING_CALL);
    if (confirm('User ' + message.from
      + ' is calling you. Do you accept the call?')) {
      // this.showSpinner(videoInput, videoOutput);

      const options = {
        localVideo: videoInput,
        remoteVideo: videoOutput,
        onicecandidate: this.onIceCandidate
      };
      /*
      webRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendrecv(options,
        function(error) {
          if (error) {
            console.error(error);
            setCallState(NO_CALL);
          }

          // tslint:disable-next-line:no-shadowed-variable
          this.generateOffer((error, offerSdp) => {
            if (error) {
              console.error(error);
              setCallState(NO_CALL);
            }
            // tslint:disable-next-line:no-shadowed-variable
            const response = {
              id : 'incomingCallResponse',
              from : message.from,
              callResponse : 'accept',
              sdpOffer : offerSdp
            };
            sendMessage(response);
          });
        });*/

    } else {
      response = {
        id: 'incomingCallResponse',
        from: message.from,
        callResponse: 'reject',
        message: 'user declined'
      };
      sendMessage(response);
      this.stop(true);
    }
  }
  register(card) {
    // var name = document.getElementById('name').value;
    // window.alert(card);
    if (card === '') {
      // window.alert('You must insert your user name');
      return;
    }

    this.setRegisterState(REGISTERING);

    const message = {
      id : 'register',
      name : card
    };
    sendMessage(message);
    // document.getElementById('peer').focus();
  }
  call() {
    /*if (document.getElementById('peer').value === '') {
      window.alert('You must specify the peer name');
      return;
    }*/
    this.displayWaitDialog = false;
    setCallState(PROCESSING_CALL);

    // this.showSpinner(videoInput, videoOutput);

    const options = {
      localVideo: videoInput,
      remoteVideo: videoOutput,
      onicecandidate: this.onIceCandidate
    };

    /*
    webRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerSendrecv(options, function(
      error) {
      if (error) {
        setCallState(NO_CALL);
        console.error(error);
      }
      this.generateOffer((error2, offerSdp) => {
        if (error2) {
          setCallState(NO_CALL);
          console.error(error2);
        }
        const message = {
          id : 'call',
          from : '502605020', // card, // document.getElementById('name').value,
          to : '502-1-4328', // parentCall, // document.getElementById('peer').value,
          sdpOffer : offerSdp
        };
        sendMessage(message);
        console.log('WebRtcPeer' + JSON.stringify(message));
      });
    });*/
  }
  closeWs() {
    //ws.close(2, 'finished call');
  }
  stop(message) {
    setCallState(NO_CALL);
    if (webRtcPeer) {
     // webRtcPeer.dispose();
     // webRtcPeer = null;

     if (!message) {
        // tslint:disable-next-line:no-shadowed-variable
        const message = {
          id : 'stop'
        };
        //sendMessage(message);
      }
    }
    // this.hideSpinner(videoInput, videoOutput);
  }
  onIceCandidate(candidate) {
    console.log('Local candidate' + JSON.stringify(candidate));

    const message = {
      id: 'onIceCandidate',
      onicecandidate: candidate
    };
    // sendMessage(message);
    const jsonMessage = JSON.stringify(message);
    if (ws !== undefined) {
      ws.send(jsonMessage);
    } else {
      alert('No se pudo establecer conexión con el doctor/a por favor recargar la pagina.');
    }
  }

  /*showSpinner() {
    for (let i = 0; i < arguments.length; i++) {
      arguments[i].poster = './img/transparent-1px.png';
      arguments[i].style.background = 'center transparent url("./img/spinner.gif") no-repeat';
    }
  }

  hideSpinner() {
    for (let i = 0; i < arguments.length; i++) {
      arguments[i].src = '';
      arguments[i].poster = './img/webrtc.png';
      arguments[i].style.background = '';
    }
  }*/
  setRegisterState(nextState) {
    switch (nextState) {
      case NOT_REGISTERED:
        // $('#register').attr('disabled', false);
        // $('#call').attr('disabled', true);
        // $('#terminate').attr('disabled', true);
        break;

      case REGISTERING:
        // $('#register').attr('disabled', true);
        break;

      case REGISTERED:
        // $('#register').attr('disabled', true);
        setCallState(NO_CALL);
        break;

      default:
        return;
    }
    registerState = nextState;
  }
}
